import { render } from "./Animation.vue?vue&type=template&id=067be8de&scoped=true"
const script = {}

import "./Animation.vue?vue&type=style&index=0&id=067be8de&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067be8de"]])

export default __exports__